import AuthAPI from './auth'
import store from '../store'

let bootstrapPromise = null

function isPrerenderBuild() {
  return typeof window !== 'undefined' && Boolean(window.__PRERENDER_INJECTED)
}

export function bootstrapAuth() {
  if (isPrerenderBuild()) {
    store.commit('setUser', null)
    return Promise.resolve(null)
  }

  if (!bootstrapPromise) {
    bootstrapPromise = AuthAPI.me()
      .then(({ data }) => {
        store.commit('setUser', data)
        return data
      })
      .catch(() => {
        store.commit('setUser', null)
        return null
      })
  }
  return bootstrapPromise
}

export function resetAuthBootstrap() {
  bootstrapPromise = null
}
